export default "__VITE_ASSET__C6Z4Rdti__"